import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type RemoteDictionariesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type RemoteDictionariesQuery = {
  __typename?: 'Query';
  jobPositions: Array<{
    __typename?: 'JobPositionType';
    jobPositionId: string;
    name: string;
    availableMainTechnologies: Array<{
      __typename?: 'AvailableMainTechnologiesResolvedType';
      name?: string | null;
      mainTechnologies: Array<{
        __typename?: 'MainTechnologiesResolvedType';
        defaultTagIds?: Array<string> | null;
        tag: { __typename?: 'ResolvedTagType'; id: string; name: string };
      }>;
    }>;
  }>;
  languages: Array<{ __typename?: 'LanguageType'; nameEn: string; languageId: string }>;
  tags: Array<{
    __typename?: 'TagType';
    id: string;
    name: string;
    type: Types.TagTypeEnum;
    displayName?: string | null;
  }>;
};

export const RemoteDictionariesDocument = gql`
  query remoteDictionaries {
    jobPositions {
      jobPositionId
      name
      availableMainTechnologies {
        name
        mainTechnologies {
          tag {
            id
            name
          }
          defaultTagIds
        }
      }
    }
    languages {
      nameEn
      languageId
    }
    tags {
      id
      name
      type
      displayName
    }
  }
`;

/**
 * __useRemoteDictionariesQuery__
 *
 * To run a query within a React component, call `useRemoteDictionariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteDictionariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteDictionariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRemoteDictionariesQuery(
  baseOptions?: Apollo.QueryHookOptions<RemoteDictionariesQuery, RemoteDictionariesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RemoteDictionariesQuery, RemoteDictionariesQueryVariables>(
    RemoteDictionariesDocument,
    options,
  );
}
export function useRemoteDictionariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RemoteDictionariesQuery,
    RemoteDictionariesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RemoteDictionariesQuery, RemoteDictionariesQueryVariables>(
    RemoteDictionariesDocument,
    options,
  );
}
export function useRemoteDictionariesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RemoteDictionariesQuery, RemoteDictionariesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RemoteDictionariesQuery, RemoteDictionariesQueryVariables>(
    RemoteDictionariesDocument,
    options,
  );
}
export type RemoteDictionariesQueryHookResult = ReturnType<typeof useRemoteDictionariesQuery>;
export type RemoteDictionariesLazyQueryHookResult = ReturnType<
  typeof useRemoteDictionariesLazyQuery
>;
export type RemoteDictionariesSuspenseQueryHookResult = ReturnType<
  typeof useRemoteDictionariesSuspenseQuery
>;
export type RemoteDictionariesQueryResult = Apollo.QueryResult<
  RemoteDictionariesQuery,
  RemoteDictionariesQueryVariables
>;
export function refetchRemoteDictionariesQuery(variables?: RemoteDictionariesQueryVariables) {
  return { query: RemoteDictionariesDocument, variables };
}
